import axios from '@/axios';
import { addAttendanceTypeTransformer } from './transformer';
import { vacationType } from '@/utils/enum';

export default {
	actions: {
		// ---- get
		async fetchAttendanceTypes() {
			return axios.get('/SettingsAttend/PermenantSystem').then(({ data }) => data);
		},
		async fetchVacationsTypes() {
			return axios
				.get('/SettingsHr/LeavesOrPermissionType')
				.then(({ data }) =>
					data && data.length ? data.filter((e) => e.type === vacationType.vacation.value) : [],
				);
		},
		async fetchPermissionsTypes() {
			return axios
				.get('/SettingsHr/LeavesOrPermissionType')
				.then(({ data }) =>
					data && data.length ? data.filter((e) => e.type === vacationType.permission.value) : [],
				);
		},
		async fetchMissionsTypes() {
			return axios.get('/SettingsHr/TaskTypes').then(({ data }) => data);
		},

		// ---- post
		async addDailyAttendanceType(_, { id, ...props }) {
			const payload = addAttendanceTypeTransformer(props);

			return id
				? axios.put(`/SettingsAttend/PermanentSystem/${id}/DailySystem`, payload)
				: axios.post('/SettingsAttend/DailySystem', payload);
		},

		async addHybridAttendanceType(_, { id, ...props }) {
			const payload = addAttendanceTypeTransformer(props);

			return id
				? axios.put(`/SettingsAttend/PermanentSystem/${id}/Hybrid`, payload)
				: axios.post('/SettingsAttend/HybridSystem', payload);
			
		},
		
		async addHourlyAttendanceType(_, { id, name, hoursCount }) {
			return id
				? axios.put(`/SettingsAttend/PermanentSystem/${id}/HourlySystem`, { name, hoursCount })
				: axios.post('/SettingsAttend/HoursSystem', { name, hoursCount });
		},

		async addVacationType(_, { id, ...props }) {
			let employeeIds = [];
			if (!props.forAll) {
				employeeIds = props.employees.map((e) => e.employeeId);
			}

			const payload = {
				type: vacationType.vacation.value,

				name: props.name,
				maxCount: props.maxCount,
				withSalary: props.withSalary,
				discountPercentage: props.discountPercentage,
				repetition: props.repetition,
				employeeIds,
			};

			return axios.postput('/SettingsHr/LeavesOrPermissionType', id, payload);
		},

		async addPermissionType(_, { id, ...props }) {
			const payload = {
				type: vacationType.permission.value,

				name: props.name,
			};
			return axios.postput('/SettingsHr/LeavesOrPermissionType', id, payload);
		},

		async addMissionType(_, { id, name, percentage }) {
			return id
				? axios.put('/SettingsHr/TaskType/' + id, null, {
						params: { name, percentage },
				  })
				: axios.post('/SettingsHr/TaskType', null, {
						params: { name, percentage },
				  });
		},
	},
};
